<span class="light-bold ">{{(labelObs | async | translate) + ': '}}</span> {{(displayObs | async | translate )}}